import axiosInstance from './base.api';
import { getEnvironmentVariable } from '../utils';
import { FormsDTO, FormsResultDTO, FormsResultsDTO, UploadFormFileDTO } from '../types/forms';

export const submitForm = async (data: any): Promise<void> => {
    await axiosInstance.post('/forms/responses', data);
};

const baseUrl = getEnvironmentVariable('REACT_APP_IMAGE_BASE_URL');
const IMAGE_BASE_URL = `${baseUrl}/img/appicons`;

export const getForms = async (): Promise<FormsDTO['data']> => {
    const response = await axiosInstance.get<FormsDTO>('/decisions/list/forms');
    return response.data.data.map(item => {
        return {
            ...item,
            icon: `${IMAGE_BASE_URL}/${item.icon}`,
        };
    });
};

export const deleteFormResponse = async (formId: string | number, responseId: string | number): Promise<void> => {
    await axiosInstance.post(`/forms/responses/delete?form_id=${formId}&response_id=${responseId}`);
};

export const getFormsResult = async (formId: string, responseId: string): Promise<FormsResultDTO['data']> => {
    const response = await axiosInstance.post<FormsResultDTO>(`/forms/responses/details?form_id=${formId}&response_id=${responseId}`);
    return response.data.data;
};

export const getFormsResults = async (formId: string | number): Promise<FormsResultsDTO> => {
    const response = await axiosInstance.post<FormsResultsDTO>('/forms/responses/list-details?form_id=' + formId);
    return response.data;
};

export const getFormsRows = async (formId: string | number): Promise<FormsResultsDTO> => {
    const response = await axiosInstance.post<FormsResultsDTO>('/forms/rows?form_id=' + formId);
    return response.data;
};

export const uploadFormsFile = async (formId: string | number, file: File): Promise<UploadFormFileDTO> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axiosInstance.post<UploadFormFileDTO>('/forms/upload', formData, {
        params: { form_id: formId },
    });

    return response.data;
};
